import React from "react";
import flagGermany from "assets/images/Flag_of_Germany.svg";
import flagUnitedKingdom from "assets/images/Flag_of_the_United_Kingdom.svg";
import { useLeonardoLocale } from "scenes/leonardoNikolai/LeonardoLocaleContext";
import "styles/leonardo-nikolai.css";

const LeonardoLanguageToggle = ({ className = "" }) => {
  const { locale, setLocale, updating, t } = useLeonardoLocale();

  return (
    <div
      className={["leonardo-lang-toggle", className].filter(Boolean).join(" ")}
      role="group"
      aria-label={t("lang.switch")}
    >
      <button
        type="button"
        className={locale === "de" ? "is-active" : ""}
        onClick={() => setLocale("de")}
        lang="de"
        disabled={updating}
        aria-pressed={locale === "de"}
        aria-label="Deutsch"
      >
        <img src={flagGermany} alt="" aria-hidden="true" />
      </button>
      <button
        type="button"
        className={locale === "en" ? "is-active" : ""}
        onClick={() => setLocale("en")}
        lang="en"
        disabled={updating}
        aria-pressed={locale === "en"}
        aria-label="English"
      >
        <img src={flagUnitedKingdom} alt="" aria-hidden="true" />
      </button>
    </div>
  );
};

export default LeonardoLanguageToggle;
